import React from 'react';
import classNames from 'classnames/bind';
import { SkeletonBrick } from '@carnica/ui-kit';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var SKELETON_FIRST_SIZE = {
  height: {
    desktop: 24,
    mobile: 16
  },
  width: {
    desktop: 200,
    mobile: 120
  }
};
export var SKELETON_SECOND_SIZE = {
  height: {
    desktop: 40,
    mobile: 26
  },
  width: {
    desktop: 120,
    mobile: 72
  }
};
export var BalanceLoading = function BalanceLoading() {
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container'),
    "data-t-id": "components-Balance"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('block')
  }, /*#__PURE__*/React.createElement(SkeletonBrick, {
    height: SKELETON_FIRST_SIZE.height,
    width: SKELETON_FIRST_SIZE.width
  }), /*#__PURE__*/React.createElement(SkeletonBrick, {
    height: SKELETON_SECOND_SIZE.height,
    width: SKELETON_SECOND_SIZE.width
  })));
};